import React, { useState, useEffect } from 'react';

import { Form, Radio, Checkbox, Col, Row, message } from 'antd';
import { violationOptions } from 'constants/content-review';
import * as api from 'api';
import './index.css';

// props type:
// {
// 	chat: {
// 		question: object,
// 		answer: object
// 	}
//  onFormSubmitted: function
//}
const ChatReviewForm = (props) => {
	const [answerReviewForm] = Form.useForm();
	const [questionReviewForm] = Form.useForm();

	const [answerCorrect, setAnswerCorrect] = useState(null);
	const [questionIllegal, setQuestionIllegal] = useState(null);
	const [submitButtonEnabled, setSubmitButtonEnabled] = useState([false, false]);

	useEffect(() => {
		// review result will be like:
		// {
		// 	"correct": true,
		// 	"illusion": false,
		// 	"isViolation": null,
		// 	"violation": []
		// }
		const reviewStatus = props?.chat?.answer?.review;
		const answerCorrect = reviewStatus?.correct ?? null;
		const isIllusion = reviewStatus?.illusion ?? null;
		const isViolation = reviewStatus?.isViolation ?? null;
		const violationReason = reviewStatus?.violation ?? [];
		answerReviewForm.setFieldsValue({
			correct: answerCorrect + '',
			illusion: isIllusion + '',
		});
		setAnswerCorrect(answerCorrect + '');
		questionReviewForm.setFieldsValue({
			isViolation: isViolation + '',
			violation: violationReason,
		});

		setQuestionIllegal(isViolation + '');
		setSubmitButtonEnabled([false, false]);
	}, [props.chat]);

	// MARK: - from actions

	// type:
	//    0 for answer review form
	//    1 for question review form
	const onFormValuesChange = (type) => (_, allValues) => {
		const buttonStatus = [...submitButtonEnabled];
		if (type === 0) {
			setAnswerCorrect(allValues.correct);
			buttonStatus[0] =
				allValues.correct === 'true'
					? true
					: allValues.correct === 'false' && answerReviewForm.getFieldValue('illusion') !== 'null';

			if (allValues.correct === 'true') {
				answerReviewForm.setFieldsValue({
					illusion: null,
				});
			}
		} else {
			setQuestionIllegal(allValues.isViolation);
			buttonStatus[1] =
				allValues.isViolation === 'false'
					? true
					: allValues.isViolation === 'true' && questionReviewForm.getFieldValue('violation')?.length > 0;
			if (allValues.isViolation === 'false') {
				questionReviewForm.setFieldsValue({
					violation: [],
				});
			}
		}

		setSubmitButtonEnabled(buttonStatus);
	};

	// type:
	//    0 for answer review form
	//    1 for question review form
	const onFormSubmit = (type) => {
		const msgId = type === 0 ? props.chat.answer.msgId : props.chat.question.msgId;
		const payload =
			type === 0
				? {
						correct: JSON.parse(answerReviewForm.getFieldValue('correct')),
						illusion: JSON.parse(answerReviewForm.getFieldValue('illusion')),
					}
				: {
						isViolation: JSON.parse(questionReviewForm.getFieldValue('isViolation')),
						violation: questionReviewForm.getFieldValue('violation'),
					};
		api.reviewChat(msgId, payload).then((res) => {
			props.onFormSubmitted();
			message.success('Form submitted successfully!');
		});
	};

	return (
		<div className="chat-review-form-container">
			<div className="answer-review-form-container">
				<div className="content-review-section-header">Professional Review</div>
				<Form
					name="answer_review_form"
					form={answerReviewForm}
					layout="horizontal"
					initialValues={{
						correct: null,
						illusion: null,
					}}
					autoComplete="off"
					onValuesChange={(changedValues, allValues) => onFormValuesChange(0)(changedValues, allValues)}
				>
					<Form.Item name="correct" label={'AI回答是否正确'}>
						<Radio.Group>
							<Radio value="true"> 正确 </Radio>
							<Radio value="false"> 不正确 </Radio>
						</Radio.Group>
					</Form.Item>
					{answerCorrect === 'false' ? (
						<Form.Item name="illusion" label={'是否为AI幻觉'}>
							<Radio.Group>
								<Radio value="true"> 是 </Radio>
								<Radio value="false"> 否 </Radio>
							</Radio.Group>
						</Form.Item>
					) : (
						<div className="no-more-option-placeholder">
							{answerCorrect === 'true' ? '无更多选项，请直接提交。' : ''}
						</div>
					)}
				</Form>
				<div className="submit-button-container">
					<div
						className={`app-btn app-btn-primary app-btn-submit ${!submitButtonEnabled[0] && 'app-btn-disabled'}`}
						onClick={() => onFormSubmit(0)}
					>
						Submit
					</div>
				</div>
			</div>
			<div className="answer-review-form-container">
				<div className="content-review-section-header">Security Review</div>
				<Form
					name="question_review_form"
					form={questionReviewForm}
					layout="horizontal"
					initialValues={{
						isViolation: null,
						violation: [],
					}}
					autoComplete="off"
					onValuesChange={(changedValues, allValues) => onFormValuesChange(1)(changedValues, allValues)}
				>
					<Form.Item name="isViolation" label={'用户提问是否违规'}>
						<Radio.Group>
							<Radio value="false"> 未违规 </Radio>
							<Radio value="true"> 违规 </Radio>
						</Radio.Group>
					</Form.Item>
					{questionIllegal === 'true' ? (
						<Form.Item name="violation" label={'问答内容是否包含以下违禁问题(至少选一项)'} layout="vertical">
							<Checkbox.Group>
								<Col>
									{violationOptions.map((item, index) => (
										<Row key={`violation-item-${index}`} span={8} style={{ lineHeight: '32px' }}>
											<Checkbox value={item.value}>{item.label}</Checkbox>
										</Row>
									))}
								</Col>
							</Checkbox.Group>
						</Form.Item>
					) : (
						<div className="no-more-option-placeholder">
							{questionIllegal === 'false' ? '无更多选项，请直接提交。' : ''}
						</div>
					)}

					<div className="submit-button-container">
						<div
							className={`app-btn app-btn-primary app-btn-submit ${!submitButtonEnabled[1] && 'app-btn-disabled'}`}
							onClick={() => onFormSubmit(1)}
						>
							Submit
						</div>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default ChatReviewForm;
